import { AudioInputState, Cover, SelectedFileNoDates } from "@/types/types";
import { isSelectedCover } from "@/utils/selectedFileCover/is/isSelectedCover";
import { stringifyDatesSound } from "@/utils/serverClientSerialization/stringifyDatesSound";

export const stringifyDatesSelectedFileCover = (
  selectedFileCover: NonNullable<AudioInputState["selectedFileCover"]>
): Cover | SelectedFileNoDates => {
  if (isSelectedCover(selectedFileCover)) {
    return selectedFileCover;
  }

  const { selectedSound, ...newSelectedFileCover } = selectedFileCover;

  const stringifiedFileCover = {
    ...newSelectedFileCover,
    abortController: undefined,
    selectedSound:
      selectedSound === null ? null : stringifyDatesSound(selectedSound),
  };

  return stringifiedFileCover;
};
